import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';
import { AppState } from 'src/app/store/app.state';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {

  @Input() pageTitle: string = '';

  @ViewChild('sidenav') sidenav!: MatSidenav;

  showSideNav$: Observable<any>;
  showSidenav: Boolean;

  userProfile: any;

  ngUnsubsribe = new Subject();

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService,
    private offlineStorageService: OfflineStorageService
  ) {}

  async ngOnInit() {
    const user = await this.offlineStorageService.getObject('user');
    if (user) {
      this.userProfile = JSON.parse(user);
    }
  }

  toggleSidenav() {
    this.sharedService.toggle();
  }

}
